export default {
    settingsTab: 'Apple / Google Wallet',
    pageTitle: 'Prepaid wallet passes',
    masterToggleTitle: 'Enable prepaid wallet passes',
    masterToggleHelp: 'When enabled, workspace admins can allocate prepaid wallet passes from Hardware and user profiles.',
    planSectionTitle: 'Bulk wallet plan',
    planCreate: 'Create plan',
    planUpdate: 'Update plan',
    totalPasses: 'Total passes',
    subscriptionStart: 'Subscription start',
    subscriptionEnd: 'Subscription end',
    notes: 'Notes',
    settings: 'Apple / Google Wallet settings',
    remainingPasses: 'Remaining passes',
    allocatedPasses: 'Allocated passes',
    planStatus: 'Plan status',
    allocatedAt: 'Allocated',
    noActivePlan: 'No active bulk wallet plan for this workspace.',
    contactSuperAdmin: 'Contact your Swiftlane admin to enable a bulk wallet plan.',
    assignPasses: 'Assign passes',
    revokeSelected: 'Revoke selected',
    allocationsList: 'Allocations',
    assignModalTitle: 'Select users to allocate',
    allocateResults: 'Allocation results',
    revokeResults: 'Revoke results',
    user: 'User',
    status: 'Status',
    profileSectionTitle: 'Prepaid wallet pass',
    allocateUser: 'Allocate pass',
    /** Re-allocate a previously revoked user from the allocations table */
    allocateRevokedUser: 'Allocate again',
    revokeUser: 'Revoke pass',
    notAllocated: 'No prepaid wallet allocation for this user.',
    prepaidActive: 'User has an active prepaid wallet allocation.',
    selectUsersFirst: 'Select at least one user.',
    selectRowsToRevoke: 'Select users to revoke.',
    confirmRevoke: 'Revoke prepaid wallet for selected users?',
    deepLinkDisabledTitle: 'Prepaid wallet is not enabled',
    deepLinkDisabledDescription: 'This section is available when prepaid wallet is enabled for your workspace.',
};
